export default "__VITE_ASSET__CHBPS4Mt__"